import type StyleSettingsModule from "./styleSettingsModule";
import type ThematicSettingsModule from "./thematicSettingsModule";

export default class PolygonStyleSettingsModule {
    private styleSettings: StyleSettingsModule;
    private thematicSettings: ThematicSettingsModule;

    constructor(styleSettings: StyleSettingsModule, thematicSettings: ThematicSettingsModule) {
        this.styleSettings = styleSettings;
        this.thematicSettings = thematicSettings;
    }

    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        // TODO FIXME will not return attributes required for labeling...
        
        let requiredAttributes: string[] = [];
        if (styleSettings.conditionalStyleSettings) {
            var attrs = this.styleSettings.ConditionalStyleSettings.getRequiredAttributes(styleSettings.conditionalStyleSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.colorThematicSettings) {
            var attrs = this.thematicSettings.getRequiredAttributes(styleSettings.colorThematicSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.colorPerFeatureSettings) {
            var attrs = this.styleSettings.ColorPerFeatureSettings.getRequiredAttributes(styleSettings.colorPerFeatureSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        return _.uniq(requiredAttributes);
    }
}
